import { useEffect, useState } from "react";
import NoIndex from '../../components/NoIndex';

import GuidanceDesc from "./items/1.desc";
import GuidanceSearch from "./items/2.search";
import GuidanceOrder from "./items/3.order";

export type GuidanceUser = {
  school: string;
  grade: string;
  className: string;
  course: string;
  name: string;
  number: string;
};

export type RecruitItem = {
  recruitId: string;
  companyId: string;
  name: string;
  image?: string;
  storeImage?: string;
};

type Props = {
  school: string;
  // 順位付けの学校は、第1志望〜第rankCount志望まで順番をつける（0 なら志望群）。config.ts 参照
  rankCount?: number;
  // false の学校は「内定承諾済み」を選ぶ確認画面を出さない(1年生向けのYICなど)
  showOfferAccepted?: boolean;
};

export default function GuidancePage({ school, rankCount = 0, showOfferAccepted = true }: Props) {

  const [ step, setStep ] = useState<"desc" | "search" | "order">("desc");
  const [ userInfo, setUserInfo ] = useState<GuidanceUser>({ school, grade: "", className: "", course: "", name: "", number: "" });
  const [ likes, setLikes ] = useState<RecruitItem[]>([]);
  const [ firstList, setFirstList ] = useState<string[]>([]);
  const [ secondList, setSecondList ] = useState<string[]>([]);
  // 順位付けの学校: rankList[i] が第(i+1)志望の recruitId
  const [ rankList, setRankList ] = useState<string[]>([]);

  // 画面(説明 → 検索 → 志望)が変わったら一番上から見せる。前の画面のスクロール位置が残っていたため。
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  return (
    <>
      <NoIndex title="進路指導 | memorii works" />
      {step === "desc" && (
        <GuidanceDesc
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          rankCount={rankCount}
          showOfferAccepted={showOfferAccepted}
          onNext={() => setStep("search")}
        />
      )}

      {step === "search" && (
        <GuidanceSearch
          userInfo={userInfo}
          likes={likes}
          setLikes={setLikes}
          rankCount={rankCount}
          onBack={() => setStep("desc")}
          onNext={() => setStep("order")}
        />
      )}

      {step === "order" && (
        <GuidanceOrder
          userInfo={userInfo}
          likes={likes}
          firstList={firstList}
          setFirstList={setFirstList}
          secondList={secondList}
          setSecondList={setSecondList}
          rankCount={rankCount}
          rankList={rankList}
          setRankList={setRankList}
          onBack={() => setStep("search")}
        />
      )}
    </>
  );
}
